import api from '@/api'

export default {
  namespaced: true,
  state: {
    totalTokens: 0,
    tokens: [],
    fetching: false
  },
  actions: {
    async fetchTokens ({ state, commit }, { options }) {
      commit('fetching')

      try {
        const { items } = await api.getTokens(options)

        commit('setFetchDataTokens', items)
      } catch (err) {
        commit('setFetchDataTokens', [])
      }
    },
    async addToken ({ state, commit }, id) {
      commit('fetching')

      try {
        const token = await api.getToken(id)

        commit('addDataToken', token)
      } catch (err) {
      }
    }
  },
  getters: {
    getToken: state => id => state.tokens.find(token => token._id.$oid === id)
  },
  mutations: {
    setFetchDataTokens (state, tokens) {
      state.tokens = tokens
      state.totalTokens = tokens.length
      state.fetching = false
    },
    addDataToken (state, token) {
      state.tokens.push(token)
      state.totalTokens = state.tokens.length
      state.fetching = false
    },
    fetching (state) {
      state.fetching = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/toolApi.js